import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Users, Calendar, FileText, ClipboardCheck, Clock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function HRDashboardPage() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({ candidates: 0, interviews: 0, offers: 0, onboarding: 0, probation: 0 });

  useEffect(() => {
    const load = async () => {
      try {
        const [cR, iR, oR] = await Promise.allSettled([
          api.get('/candidates?pageSize=1'), api.get('/interviews?pageSize=1'), api.get('/offers?pageSize=1'),
        ]);
        setStats({
          candidates: cR.status === 'fulfilled' ? (cR.value.data.total || 0) : 0,
          interviews: iR.status === 'fulfilled' ? (iR.value.data.total || 0) : 0,
          offers: oR.status === 'fulfilled' ? (oR.value.data.total || 0) : 0,
          onboarding: 0, probation: 0,
        });
      } catch (e) {}
    };
    load();
  }, []);

  const cards = [
    { label: 'Candidates', value: stats.candidates, icon: Users, color: 'text-primary', path: '/hr/recruitment' },
    { label: 'Interviews', value: stats.interviews, icon: Calendar, color: 'text-purple-600', path: '/hr/recruitment' },
    { label: 'Offers', value: stats.offers, icon: FileText, color: 'text-teal-600', path: '/hr/recruitment' },
    { label: 'Onboarding', value: stats.onboarding, icon: ClipboardCheck, color: 'text-amber-600', path: '/hr/recruitment' },
  ];

  return (
    <div className="space-y-6 animate-fade-in">
      <div><h1 className="text-2xl font-bold tracking-tight">HR Dashboard</h1><p className="text-muted-foreground mt-1">Recruitment & onboarding overview</p></div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {cards.map(c => (
          <Card key={c.label} className="cursor-pointer hover:border-primary/30" onClick={() => navigate(c.path)}>
            <CardContent className="p-4"><c.icon className={`h-5 w-5 ${c.color} mb-2`} /><p className="text-2xl font-bold">{c.value}</p><p className="text-xs text-muted-foreground">{c.label}</p></CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
